var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLogo',_vm._g(_vm._b({attrs:{"form":_vm.form,"shade":_vm.compShade}},'BaseLogo',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }